// src/services/auth/context.ts

import { createContext } from "react";
import type { AuthService } from "./AuthService";

/**
 * React Context for AuthService
 * Provides the authentication service instance to the entire app
 */
export const AuthServiceContext = createContext<AuthService | null>(null);
